import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store-redux/store';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import LoadingSpinner from 'components/UI/loading-spinner/LoadingSpinner';
import './language-file/i18n'; // Initialize i18n

const addScript = (src) => {
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
};

// Dynamically add reCAPTCHA script
addScript(`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_MODE === 'Dev' ? process.env.REACT_APP_RECAPTCHA_SITE_KEY_TEST : process.env.REACT_APP_MODE === 'userDev' ? process.env.REACT_APP_RECAPTCHA_SITE_KEY_USER_TEST : process.env.REACT_APP_RECAPTCHA_SITE_KEY_LIVE}`);

console.log("env dev mode in index.js", process.env.REACT_APP_MODE)


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
